var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1560",
    d: "M34.6331 30.0449C35.8317 29.3385 36.636 28.0342 36.636 26.5423C36.636 24.2983 34.817 22.4793 32.5731 22.4793C30.3293 22.4793 28.5103 24.2983 28.5103 26.5423C28.5103 27.8746 29.1515 29.057 30.1423 29.798",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1564",
    d: "M35.4503 36.5898C39.8238 35.3421 43.0258 31.316 43.0258 26.542C43.0258 20.7721 38.3483 16.0946 32.5784 16.0946C26.8083 16.0946 22.1309 20.7721 22.1309 26.542C22.1309 31.2301 25.2187 35.1971 29.4715 36.5198",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1568",
    d: "M47.2442 14.9453C46.0033 16.1862 43.9915 16.1862 42.7505 14.9453C41.5096 13.7043 41.5096 11.6925 42.7505 10.4516C43.9915 9.21061 46.0033 9.21061 47.2442 10.4516C48.4852 11.6925 48.4852 13.7043 47.2442 14.9453Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1572",
    d: "M22.3976 42.6328C21.1566 43.8737 19.1448 43.8737 17.9039 42.6328C16.6629 41.3918 16.6629 39.38 17.9039 38.1391C19.1448 36.8981 21.1566 36.8981 22.3976 38.1391C23.6385 39.38 23.6385 41.3918 22.3976 42.6328Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1576",
    d: "M35.4478 44.8955C44.3418 43.515 51.1491 35.8239 51.1491 26.543C51.1491 22.335 49.7495 18.4542 47.3909 15.3399",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1580",
    d: "M31.4852 8.00001C21.7339 8.56334 14 16.6495 14 26.5419C14 30.782 15.421 34.6902 17.8126 37.8164",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1584",
    d: "M53.0014 63.7998V50.2436C53.0014 48.6282 51.6918 47.3186 50.0764 47.3186C48.461 47.3186 47.1515 48.6282 47.1515 50.2436V47.9171C47.1515 46.3017 45.8419 44.9922 44.2265 44.9922C42.611 44.9922 41.3014 46.3017 41.3014 47.9171C41.3014 46.3017 39.9919 44.9922 38.3765 44.9922C36.7611 44.9922 35.4515 46.3017 35.4515 47.9171V32.0679C35.4515 30.4525 34.142 29.1429 32.5265 29.1429C30.9111 29.1429 29.6015 30.4525 29.6015 32.0679V46.0286V58.1058L26.0722 52.3149C25.2045 50.8913 23.3594 50.4202 21.9155 51.2539C20.523 52.0578 19.9866 53.8 20.6859 55.2478L24.9192 63.7998",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1588",
    d: "M35.4478 47.9174V53.6211",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1592",
    d: "M41.2944 47.9174V54.0342",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1596",
    d: "M47.1479 50.2434V54.1104",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 652",
    cx: 32,
    cy: 27,
    r: 18,
    fill: "url(#paint0_linear_220_3540)",
    fillOpacity: 0.24
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_3540",
    x1: 35,
    y1: 9,
    x2: 35,
    y2: 50.1429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevolution);
export default __webpack_public_path__ + "static/media/revolution.0f244449e482b05a1ee05918ccf24c59.svg";
export { ForwardRef as ReactComponent };